import { useState } from 'react';
import { Search, ChevronDown } from 'lucide-react';

const FAQS = [
  { c: 'Delivery', q: 'How does delivery scheduling work?', a: 'At checkout you choose your preferred delivery date and a courier window — morning, afternoon or evening. We ship worldwide from our atelier.' },
  { c: 'Delivery', q: 'How long until my order ships?', a: 'In-stock pieces are dispatched within 1–3 business days. Presale pieces ship on the dispatch date shown on the product page. You get an email when your parcel is on its way.' },
  { c: 'Delivery', q: 'What are your shipping rates?', a: 'UAE: Free (2–4 days). GCC: $15 (3–6 days). Europe & UK: $25 (5–9 days). North America: $30 (6–10 days). Rest of world: $35 (7–14 days). Duties, where applicable, are payable on receipt.' },
  { c: 'Gifting', q: 'Can I send an order as a gift?', a: 'Yes. Add our signature gift wrapping ($15) at checkout — a hand-tied box with a gold seal — and include a personal message we hand-write on a card. Prices are never shown on gift orders.' },
  { c: 'Sizing', q: 'How do I find my ring size?', a: 'Wrap a strip of paper around your finger, mark where it overlaps and measure the length (inner circumference). US 5 ≈ 15.7mm up to US 10 ≈ 19.8mm. A size guide is on every ring page.' },
  { c: 'Sizing', q: 'How are cuffs sized?', a: 'Cuffs come in S (wrist 14–15cm), M (15–16.5cm) and L (16.5–18cm). Measure around your wrist with a soft tape and match to the size guide on each cuff.' },
  { c: 'Care', q: 'How do I care for my jewellery?', a: 'Every piece is gold-plated brass. Keep it dry, apply perfume and lotion before wearing, store in the pouch provided and buff gently with a soft dry cloth. Never use chemical polishes.' },
  { c: 'Orders', q: 'What payment methods do you accept?', a: 'We accept all major cards through a secure encrypted checkout, processed globally.' },
  { c: 'Orders', q: 'What is a presale piece?', a: 'Presale pieces are still being made in our atelier. Reserve yours now and it ships on the dispatch date shown; you can track it in your account.' },
  { c: 'Returns', q: 'Can I return or exchange an item?', a: 'Unworn pieces in original condition can be returned within 14 days of delivery. Contact our concierge to arrange a return or size exchange.' },
  { c: 'Contact', q: 'How do I reach you?', a: 'Message us on Instagram @_ke_sa or WhatsApp +971 52 357 7644 — we reply within one business day.' },
];

function Item({ f }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-border" data-testid="faq-item">
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between py-5 text-left">
        <span className="font-serif text-lg pr-4">{f.q}</span>
        <ChevronDown size={18} className={`text-gold transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && <p className="text-sm text-muted-foreground leading-relaxed pb-5 -mt-1">{f.a}</p>}
    </div>
  );
}

export default function FAQ() {
  const [q, setQ] = useState('');
  const filtered = FAQS.filter((f) => (f.q + f.a + f.c).toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="px-4 sm:px-8 lg:px-16 max-w-3xl mx-auto py-16 lg:py-24">
      <p className="eyebrow mb-3">Client Care</p>
      <h1 className="font-serif text-4xl lg:text-6xl mb-8">Questions & Answers</h1>

      <div className="relative mb-10">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input data-testid="faq-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search questions…"
          className="w-full bg-surface border border-border pl-10 pr-4 py-3 text-sm outline-none focus:border-gold transition-colors" />
      </div>

      {filtered.length === 0 ? (
        <p className="text-muted-foreground">No answers matched “{q}”. Message us on WhatsApp and we'll help.</p>
      ) : (
        <div>{filtered.map((f, i) => <Item key={i} f={f} />)}</div>
      )}
    </div>
  );
}
